<template>
	<div class="videolist">
		<div class="breadcrumb">视频举报列表</div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row  style="width: 100%" @current-change="handleCurrentChange">
		    <el-table-column prop="userId" label="用户ID"></el-table-column>
		    <el-table-column prop="nickName" label="用户昵称"></el-table-column>
		    <el-table-column prop="typeName" label="举报理由">
		      	<template slot-scope="scope">
		      		<span class="el-tag el-tag--primary tagmargin" v-if="scope.row.typeName">{{scope.row.typeName}}</span>
			    </template>
		    </el-table-column>
		    <el-table-column prop="content" label="举报描述" show-overflow-tooltip>
		    </el-table-column>
		    <el-table-column prop="type" label="举报类型">
		    	短视频
		    </el-table-column>
		    <el-table-column prop="video" label="举报内容">
		    	<template slot-scope="scope">
		    		<el-button type="primary" size="small" @click="watchVideo(scope.row.videoUrl)" v-if="scope.row.videoUrl">观看视频</el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column prop="beReportedUserName" label="被举报者">
		    </el-table-column>
		    <el-table-column prop="createTime" label="举报时间" :formatter="this.global.dateFormat">
		    </el-table-column>
		    <el-table-column prop="status" label="操作">
		    	<template slot-scope="scope">
		    		<el-button type="text" v-if="scope.row.status!=1">{{scope.row.status==0?'已下架':scope.row.status==1?'待审核':'上架'}}</el-button>
		    		<el-button type="primary" size='small' v-if="scope.row.status==1 || scope.row.status==0" @click="checkShortVideo(scope.row,2)">上架</el-button>
					<el-button type="danger" size='small' v-if="scope.row.status==1 || scope.row.status==2" @click="checkShortVideo(scope.row,0)">下架</el-button>
		    	</template>
		    </el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>
		<el-dialog title="视频" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
	      	<div style="max-height:500px;max-width:100%; text-align:center">
	      		<video :src="videoUrl" controls="controls" loop="-1" style="max-height:500px;max-width:100%;"></video>
	      	</div>
	    </el-dialog>

	</div>
</template>
<script>
export default {
	components: {},
  	mounted() {
  		this.init();
  	},
  	data() {
    	return {
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tableData3: [],
	        dialogVisible: false,
	        videoUrl:''
	    };
  	},
  	methods:{
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit
      		};
      		this.$get("/shortVideo/queryComplaintList",params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
  		},
	    //当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	    	this.init();
	    },
	    handleClose(done,row) {
	      	this.dialogVisible = false;
	      	this.videoUrl='';
	      	this.$refs.multipleTable.setCurrentRow(row);
	      	done();
	    },
	    handleCurrentChange(val) {
	    	
	    },
	    watchVideo(url){
	    	if(url){
	    		this.dialogVisible = true
	    		this.videoUrl=url
	    	}
	    },
	    checkShortVideo(row,type){
			if(row.videoId){
				var params = {
	        		checkType:type,
	        		userId:localStorage.getItem("userId"),
	        		videoId:row.videoId
	      		};
				this.$post("/shortVideo/checkShortVideo", JSON.stringify(params))
	        	.then(res => {
	        		console.log(res)
	          		if (res.code == 0) {
	            		this.$message({
		                    message: "操作成功",
		                    type: "success"
	                  	});
	                  	this.pageNum=1;
	                  	this.currentRow='';
	                  	this.init();
	          		} else {
	            		this.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
			}
	    }, 
  	}
}
</script>
<style scoped>
.tagmargin{
	margin:0 3px;
}
</style>


// WEBPACK FOOTER //
// src/views/videoList/videoReportList.vue